import { EventEmitter } from "@angular/core";
import { ClientsService } from "app/services/client/ClientsService";

export class QuestionChoice {

    questionLoadedEvent = new EventEmitter<any>();
    choices: any[] = [];
    private questionId: number;

    constructor(
        private _ClientsService: ClientsService,
        questionId: number
    ) {
        this.questionId = questionId;
    }

    loadQuestionsChoices() {
        //getQuestionChoices
        console.log('getQuestionChoices');
        this._ClientsService.getQuestionChoices(this.questionId, "en")
            .subscribe(res =>
            {
                this.choices = res.result;
                this.questionLoadedEvent.emit();
            });
    }

}
